import { useCallback } from 'react'
import { addEdge, MarkerType, type Connection, type Edge, type Node } from '@xyflow/react'
import { isValidSubFlowConnection } from '@/lib/subflow-utils'

export function useOnConnect(
  nodes: Node[],
  setEdges: React.Dispatch<React.SetStateAction<Edge[]>>,
  edgeKind: Edge['type']
) {
  return useCallback(
    (c: Connection) => {
      // Validar la conexión según las reglas de sub-flows
      if (!c.source || !c.target) return

      if (!isValidSubFlowConnection({ source: c.source, target: c.target }, nodes)) {
        console.warn('Conexión inválida: no se puede conectar un nodo con su padre/hijo directo')
        return
      }

      setEdges((eds) =>
        addEdge(
          {
            ...c,
            markerEnd: { type: MarkerType.ArrowClosed },
            type: edgeKind,
          },
          eds
        )
      )
    },
    [nodes, edgeKind, setEdges]
  )
}
